module.exports = __webpack_public_path__ + "img/img_applicable_01.61b3f35f.png";